<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    size: { required: false, type: String as PropType<String> },
    required: { required: false, type: Boolean as PropType<Boolean> },
  },
});
</script>
<template>
  <label
    :class="{ 'text-[11px] font-semibold': size === 'small' }"
    class="text-[#3B3A64] text-sm font-medium dark:text-light-font"
  >
    <slot></slot>
    <span v-if="required" class="text-red-500 ml-[1px] dark:text-light-purple-bar"
      >*</span
    >
  </label>
</template>
